import { useId } from 'react';

type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

/** Globe with an external-link arrow tucked into the bottom-right corner —
 *  "open the live/public page". The arrow sits in a notch masked out of the
 *  globe so it stays legible at small sizes. */
const GlobeExternalIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 24 24',
    strokeColor = 'currentColor',
    strokeWidth = '1.7',
  } = props;
  // Unique per instance — this icon can render many times in one list.
  const maskId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <mask id={maskId}>
        <rect x="0" y="0" width="24" height="24" fill="white" />
        <rect x="12.4" y="12.4" width="12" height="12" rx="3.5" fill="black" />
      </mask>
      <g
        mask={`url(#${maskId})`}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      >
        <circle cx="11" cy="11" r="8.6" />
        <path d="M2.4 11H19.6" />
        <ellipse cx="11" cy="11" rx="4" ry="8.6" />
      </g>
      <g
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15.6 20.4L20.9 15.1" />
        <path d="M16.6 15.1H20.9V19.4" />
      </g>
    </svg>
  );
};

export default GlobeExternalIcon;
